import { Dispatch, FC, SetStateAction, useMemo } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode } from 'src/custom-hooks';
import { userServices } from 'src/services';

type propsType = {
    closeShowNewUser: () => void;
    email: string;
    password: string;
    setEmail: Dispatch<SetStateAction<string>>;
    setPassword: Dispatch<SetStateAction<string>>;
};

export const UsersNewUserCreate: FC<propsType> = ({ closeShowNewUser, email, password, setEmail, setPassword }) => {
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const isValid: boolean = useMemo(() =>
        generalHelpers.IsValidEmail(email)
        && password.length >= 8
    , [email, password]);

    const registerHandler = async () => {
        if (!isValid) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: "Confirmar",
            message: `Se va a crear una cuenta con correo ${email} y contraseña "${password}"`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await userServices.RegisterAdmins(email, password);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: "Logrado",
                    message: `Se creó una cuenta con correo ${email} y contraseña "${password}"`,
                    animation: 1
                }));
                closeShowNewUser();
            }
        }));
    }

    return (
        <>
        <h3 className={`text-center mt-5 ${isDarkMode ? 'text-white' : ''}`}>
            Crear una cuenta por él
        </h3>
        <FloatingLabel className={'text-dark mt-5 mb-3'}
            label={"Correo electrónico"}
        >
            <Form.Control type={'email'}
                className={'form-control'}
                placeholder={""}
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoFocus
            />
        </FloatingLabel>
        <FloatingLabel className={'text-dark mb-3'}
            label={"Contraseña"}
        >
            <Form.Control type={'text'}
                className={'form-control'}
                placeholder={""}
                value={password}
                onChange={e => setPassword(e.target.value)}
                onKeyDown={e => e.key === 'Enter' ? registerHandler() : null}
            />
        </FloatingLabel>
        <button className={'btn btn-general-blue d-block w-100 mt-4'}
            style={{ fontWeight: 'bolder', height: '50px' }}
            onClick={registerHandler}
            disabled={!isValid}
        >
            REGISTRAR CUENTA
        </button>
        <button className={`btn btn-general-red d-block w-100 mt-3`}
            style={{ fontWeight: 'bolder', height: '50px' }}
            onClick={() => closeShowNewUser()}
        >
            Cancelar
        </button>
        </>
    );
}
